"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maybeDateToInputValue = exports.isTimezoneValid = exports.isValidDate = exports.maybeDateToDate = exports.calendarDateToDate = exports.isFormattedDate = exports.isISOString = exports.isCalendarDate = void 0;
var tslib_1 = require("tslib");
var dateFn = (0, tslib_1.__importStar)(require("date-fns"));
var is_iso_date_1 = (0, tslib_1.__importDefault)(require("is-iso-date"));
var moment_timezone_1 = (0, tslib_1.__importDefault)(require("moment-timezone"));
function isCalendarDate(value) {
    if (typeof value === 'string') {
        return false;
    }
    if (Object(value) === value && value.year && value.month && value.day) {
        return true;
    }
    return false;
}
exports.isCalendarDate = isCalendarDate;
function isISOString(value) {
    if (typeof value !== 'string')
        return false;
    return (0, is_iso_date_1.default)(value);
}
exports.isISOString = isISOString;
function isFormattedDate(value, format) {
    if (typeof value !== 'string')
        return false;
    if (value.length !== format.length)
        return false;
    return (0, moment_timezone_1.default)(value, format).isValid();
}
exports.isFormattedDate = isFormattedDate;
function calendarDateToDate(value) {
    return new Date(value.year, value.month - 1, value.day);
}
exports.calendarDateToDate = calendarDateToDate;
function maybeDateToDate(maybeDate, format, timezone) {
    if (format === void 0) { format = 'YYYY-MM-DD'; }
    if (isCalendarDate(maybeDate)) {
        return calendarDateToDate(maybeDate);
    }
    if (isISOString(maybeDate)) {
        return moment_timezone_1.default.tz(maybeDate, timezone).toDate();
    }
    if (isFormattedDate(maybeDate, format)) {
        var date = moment_timezone_1.default.tz(maybeDate, format, timezone);
        if (date.isValid()) {
            return date.toDate();
        }
    }
    throw new Error("Invalid date value ".concat(maybeDate));
}
exports.maybeDateToDate = maybeDateToDate;
function isValidDate(maybeDate, options) {
    if (options === void 0) { options = {}; }
    var disableWeekends = options.disableWeekends, maxDate = options.maxDate, maxYear = options.maxYear, minDate = options.minDate, minYear = options.minYear, _a = options.nullable, nullable = _a === void 0 ? false : _a, _b = options.format, format = _b === void 0 ? 'YYYY-MM-DD' : _b, _c = options.timezone, timezone = _c === void 0 ? moment_timezone_1.default.tz.guess() : _c;
    if (maybeDate == null || maybeDate === '') {
        return nullable;
    }
    try {
        var date = maybeDateToDate(maybeDate, format, timezone);
        if (disableWeekends && dateFn.isWeekend(date)) {
            return false;
        }
        if (minDate && dateFn.isBefore(date, minDate)) {
            return false;
        }
        if (minYear && date.getFullYear() < minYear) {
            return false;
        }
        if (maxDate && dateFn.isAfter(date, maxDate)) {
            return false;
        }
        if (maxYear && date.getFullYear() > maxYear) {
            return false;
        }
        return true;
    }
    catch (e) {
        return false;
    }
}
exports.isValidDate = isValidDate;
function isTimezoneValid(timezone) {
    return moment_timezone_1.default.tz.names().indexOf(timezone) > -1;
}
exports.isTimezoneValid = isTimezoneValid;
function maybeDateToInputValue(maybeDate, format, isDisabled, timezone) {
    if (format === void 0) { format = 'YYYY-MM-DD'; }
    if (isDisabled || maybeDate == null) {
        return null;
    }
    var checkedTimezone = moment_timezone_1.default.tz.guess();
    if (isISOString(maybeDate)) {
        if (isTimezoneValid(timezone)) {
            checkedTimezone = timezone;
        }
        return moment_timezone_1.default.tz(maybeDate, checkedTimezone).format(format);
    }
    if (isFormattedDate(maybeDate, format)) {
        try {
            return moment_timezone_1.default.tz(maybeDateToDate(maybeDate, format, timezone), timezone).format(format);
        }
        catch (e) {
            return maybeDate;
        }
    }
    if (isCalendarDate(maybeDate)) {
        return dateFn.format(calendarDateToDate(maybeDate), format);
    }
    return maybeDate;
}
exports.maybeDateToInputValue = maybeDateToInputValue;
//# sourceMappingURL=helpers.js.map